import React from 'react';
import { Controller } from 'react-hook-form';
import { Autocomplete, TextField, Chip } from '@mui/material';

const RHFMultiselect = ({
                            control,
                            name,
                            options = [],
                            label,
                            placeholder,
                            className,
                            disabled,
                            rules,
                            fixedOption,
                            getOptionLabel = (option) => option?.title ?? '',
                            isOptionEqualToValue = (option, value) => option.id === value.id,
                        }) => (
    <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState: { error } }) => {
            const value = field.value || [];

            const handleChange = (_, newValue) => {
                if (fixedOption && !newValue.some((v) => isOptionEqualToValue(fixedOption, v))) {
                    field.onChange([fixedOption, ...newValue]);
                } else {
                    field.onChange(newValue);
                }
            };

            return (
                <Autocomplete
                    multiple
                    disableCloseOnSelect
                    options={options}
                    value={value}
                    onChange={handleChange}
                    onBlur={field.onBlur}
                    disabled={disabled}
                    className={className}
                    getOptionLabel={getOptionLabel}
                    isOptionEqualToValue={isOptionEqualToValue}
                    renderTags={(tagValue, getTagProps) =>
                        tagValue.map((option, index) => {
                            const isFixed =
                                fixedOption && isOptionEqualToValue(fixedOption, option);
                            const tagProps = getTagProps({ index });
                            return (
                                <Chip
                                    {...tagProps}
                                    key={option.id ?? index}
                                    label={getOptionLabel(option)}
                                    disabled={isFixed}
                                    onDelete={isFixed ? undefined : tagProps.onDelete}
                                />
                            );
                        })
                    }
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={label}
                            placeholder={placeholder}
                            error={!!error}
                            helperText={error?.message}
                        />
                    )}
                />
            );
        }}
    />
);

export default RHFMultiselect;
